<template>
  <div class="message-item" :class="[replierType?replierType.toLowerCase():'']">
    <template v-if="message.msgLevel=='SYS'">
      <div class="notice-msg center" v-html="handlerHTML(content)"></div>
    </template>
    <template v-else>
      <div v-if="message.showTime" class="time center">{{ message.showTime }}</div>
      <div class="container flex">
        <div class="ava flex0" @click="handler(message)">
          <img :src="message|patAva" alt="">
        </div>
        <div class="content flex1">
          <div class="name">{{ message.replierName }}</div>
          <div class="msgbox flex">
            <div class="arrow flex0"></div>
            <div v-if="msgType==='MEDICAL_RECORD'" class="msg">
              <h3 class="fs12 color_999 bb pb5">{{ replyContent.title }}</h3>
              <div class="pt5 fs14 lines2">
                主诉：{{ replyContent.complained }}
              </div>
              <p class="fs10 pt5 color_main tar" @click="downloadAPP()">查看详情</p>
            </div>
            <div class="msg" v-else-if="msgType==='VIDEO'">
              <video :src="replyContent" controls></video>
            </div>
            <div class="msg" v-else-if="msgType==='DOCUMENT'">
              <file-section :info="attaList[0]"></file-section>
            </div>
            <div class="msg" v-else-if="msgType==='CARD_MESSAGE'">
              <div class="flex">
                <img class="mr10" :src="replyContent.icon" alt="" style="width: 42px;height: 42px;">
                <div>
                  <h3 class="fs15 color_333">{{ replyContent.title }}</h3>
                  <p class="fs12 color_999">{{ replyContent.desc }}</p>
                </div>
              </div>
              <div class="bt mt10 pt10">
                <span class="color_main fs12" @click="goIbdApply">{{ replyContent.urlParam }}</span>
              </div>
            </div>
            <div v-else class="msg">
              <span v-html="replyContent"></span>
              <ul v-if="message.hasAtta">
                <li v-for="atta in message.attaList">
                  <playing-icon :src="atta.url" ref="playingIcon" class="iconfont fs45 audio block"
                                @click="play(atta.url)"
                                v-if="atta.fileType&&atta.fileType=='AUDIO'">
                  </playing-icon>
                  <img :src="atta.url" @click="scan(atta.url)" @load="onLoad" v-else>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import PlayingIcon from '../../plugins/playing'
import {formatTime} from "../../lib/filter";
import patAva from '../../utils/consultPatAva'
import {handlerHTML} from "../../lib/util";

import msgItemHandle from '../../utils/msgItem'
import FileSection from "@/plugins/consult/file-section";

export default {
  props: ['message'],
  data() {
    return {};
  },
  computed: {
    content() {
      return this.message.replyContent || this.message.sendContent;
    },
    attaList() {
      return this.message.attaList || [];
    },
    msgType() {
      return this.message.msgType || "";
    },
    replierType() {
      return this.message.replierType || this.message.senderIdentity
    },
    replyContent() {
      if (this.content) {
        return msgItemHandle(this.message);
      } else {
        return ""
      }
    }
  },
  filters: {
    formatTime, patAva
  },
  components: {FileSection, PlayingIcon},
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {
    handlerHTML,
    onLoad() {
      this.$emit('imgLoad', 1);
    },

    handler(data) {
      if (data.replierType == "DOC") {
        this.$router.push({
          path: '/onlineDoctorCard',
          query: {
            docId: data.replierId
          }
        })
      }
    },

    goIbdApply() {
      this.$emit('onIbdApply', this.message);
    },
    scan(url) {
      this.$emit('scan', url);
    },
    play(url) {
      this.$emit('play', url);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../common/public";

.fs45 {
  font-size: px2rem(45px, 1080);
}

.audio {
  width: px2rem(150px);
}

video {
  max-width: 100%;
}

.bb {

}

.message-item {
  padding: 0 px2rem(15px);

  .time {
    @include h_lh(35px);
  }

  .container {
    .ava {
      padding-top: 15px;
      $w: 35px;
      @include w_h($w, $w);

      img {
        @include w_h($w, $w);
        border-radius: 50%;
      }
    }

    .msgbox {
      align-items: center;
      margin-top: 5px;
    }

    .name {
      font-size: 12px;
    }

    .arrow {
      @include w_h(10px, 10px);
      transform: rotate(45deg);
    }

    .msg {
      max-width: 13rem;
      padding: 10px;
      border-radius: 5px;

      img {
        width: 100px;
      }
    }
  }

  &.pat {
    .container {
      flex-direction: row-reverse;

      .content {
        margin-right: px2rem(10px);

        .name {
          text-align: right;
        }

        .msgbox {
          flex-direction: row-reverse;

          .arrow {
            background-color: $mainColor;
          }

          .msg {
            transform: translateX(px2rem(5px));
            color: white;
            background-color: $mainColor;
          }
        }

      }
    }
  }

  &.doc {
    .container {
      padding-top: px2rem(10px);

      .content {
        margin-left: px2rem(10px);

        .msgbox {
          .arrow {
            background-color: white;
          }

          .msg {
            transform: translateX(px2rem(-5px));
            background-color: white;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/plugins/consult/message-item.vue